import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { DischargeLetterENTFormSchema } from "./schema";
import { DischargeLetterENTFormSections } from "./sections";

export const getDischargeLetterENTFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
> = () => {
  return {
    // todo: make this optional
    auctionToForm: () => {
      return {
        additional_findings: () => undefined,
        admission_medications: () => undefined,
        anamnesis: () => undefined,
        clinical_course: () => undefined,
        diagnoses: () => undefined,
        discharge_medications: () => undefined,
        findings: () => undefined,
        laboratory_parameters: () => undefined,
        recommendations: () => undefined,
        secondary_diagnoses: () => undefined,
        therapy: () => undefined,
      };
    },
    config: { canPrint: false, canSendToHis: false },
    getInitialValue: ({ value }) => {
      return {
        additional_findings: value?.additional_findings ?? "",
        admission_medications: value?.admission_medications ?? "",
        anamnesis: value?.anamnesis ?? "",
        clinical_course: value?.clinical_course ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        findings: value?.findings ?? "",
        laboratory_parameters: value?.laboratory_parameters ?? "",
        recommendations: value?.recommendations ?? "",
        secondary_diagnoses: value?.secondary_diagnoses ?? "",
        therapy: value?.therapy ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formEnt.title,
    schema: DischargeLetterENTFormSchema,
    sections: DischargeLetterENTFormSections,
    title: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formEnt.sectionTitle,
  };
};
